import { Close, EmergencyHomeFilled, InfoFilled, WarningFilled, CheckCircleFilled } from '@interhyp/platform-icons';
import { IconButton } from '@platform/elements';
import classnames from 'classnames';
import React from 'react';
import styles from "./NoticeBanner.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const icons = {
  ERROR: /*#__PURE__*/_jsx(EmergencyHomeFilled, {
    className: styles.statusIcon
  }),
  WARNING: /*#__PURE__*/_jsx(WarningFilled, {
    className: styles.statusIcon
  }),
  INFO: /*#__PURE__*/_jsx(InfoFilled, {
    className: styles.statusIcon
  }),
  SUCCESS: /*#__PURE__*/_jsx(CheckCircleFilled, {
    className: styles.statusIcon
  })
};
export function NoticeBanner({
  notice,
  onClose
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.notice, styles[notice.type]),
    children: [icons?.[notice.type], /*#__PURE__*/_jsx("span", {
      children: notice.message
    }), /*#__PURE__*/_jsx(IconButton, {
      icon: Close,
      toolbar: true,
      tertiary: true,
      onClick: onClose
    })]
  });
}